export default function CustomServices() {
  const services = [
    'Cepillado profesional',
    'Cortes personalizados',
    'Tablas de cielo primera calidad',
    'Dimensiones especiales',
    'Asesoría técnica incluida'
  ];

  return (
    <section id="servicios" className="py-20 relative">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3a7fc118f572776a2e6df4121e2f2e9c.jpg"
          alt="Taller de Aserradero Santa Rosa"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-white/75"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-[#5D4037] text-white px-6 py-2 rounded-full text-sm font-bold mb-6">
              SERVICIOS ESPECIALES
            </div>
            <h2 className="text-5xl font-serif font-bold text-[#5D4037] mb-8 leading-tight">
              Trabajos a Medida
            </h2>
            <div className="space-y-4">
              {services.map((service, index) => (
                <div key={index} className="flex items-center gap-4">
                  <div className="w-8 h-8 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-xl"></i>
                  </div>
                  <p className="text-lg text-[#2C2416] font-medium">
                    {service}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Industrial%20wood%20planer%20machine%20in%20action%20processing%20smooth%20lumber%20boards%2C%20professional%20carpentry%20equipment%20creating%20perfectly%20finished%20timber%2C%20close%20up%20view%20of%20quality%20woodworking%20machinery%20with%20natural%20pine%20wood%20being%20milled%2C%20clean%20workshop%20environment%20with%20warm%20lighting%20highlighting%20precision%20craftsmanship%20and%20modern%20equipment&width=800&height=600&seq=planer-machine-detail&orientation=landscape"
              alt="Maquinaria de Cepillado"
              className="rounded-xl shadow-2xl w-full"
            />
            <p className="text-sm text-gray-600 italic mt-4 text-center">
              Maquinaria propia para garantizar calidad
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
